import { render, staticRenderFns } from "./BuilderAudience.vue?vue&type=template&id=10829521&scoped=true"
import script from "./BuilderAudience.vue?vue&type=script&lang=js"
export * from "./BuilderAudience.vue?vue&type=script&lang=js"
import style0 from "./BuilderAudience.vue?vue&type=style&index=0&id=10829521&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10829521",
  null
  
)

export default component.exports